var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile_svg__Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".profile_svg__cls-1{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "profile_svg__cls-1",
    d: "M5.76 19.51A5.987 5.987 0 0 1 10 17.75h10c1.59 0 3.12.63 4.24 1.76A5.987 5.987 0 0 1 26 23.75v2.5c0 .55-.45 1-1 1s-1-.45-1-1v-2.5c0-1.06-.42-2.08-1.17-2.83A4.004 4.004 0 0 0 20 19.75H10c-1.06 0-2.08.42-2.83 1.17S6 22.69 6 23.75v2.5c0 .55-.45 1-1 1s-1-.45-1-1v-2.5c0-1.59.63-3.12 1.76-4.24ZM15 4.75c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm-6 4c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6Z"
  })));
};

export default SvgProfile;